module.exports = __webpack_public_path__ + "img/nav-stonesize-3.4e337fe.svg";